import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';

const TotalSubscriberOneVolunteer = () => {
    const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
    const [barChartSeries, setBarChartSeries] = useState([]);
    const [barChartOptions, setBarChartOptions] = useState({
        chart: {
            type: "bar",
            height: 264,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                horizontal: false,
                columnWidth: 24,
                endingShape: "rounded",
            },
        },
        dataLabels: { enabled: false },
        fill: {
            type: "gradient",
            colors: ["#dae5ff"],
            gradient: {
                shade: "light",
                type: "vertical",
                shadeIntensity: 0.5,
                gradientToColors: ["#dae5ff"],
                inverseColors: false,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100],
            },
        },
        grid: {
            show: false,
            borderColor: "#D1D5DB",
            strokeDashArray: 4,
            position: "back",
            padding: {
                top: -10,
                right: -10,
                bottom: -10,
                left: -10,
            },
        },
        xaxis: {
            type: "category",
            categories: [],
        },
        yaxis: { show: false },
    });

    useEffect(() => {
        const fetchData = async () => {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_BASE_URL}/backend/volunteers/get-last-week-volunteers`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const result = await response.json();
                if (result.status) {
                    const categories = result.data.map(item => item.day);
                    const data = result.data.map(item => item.count);
                    setBarChartOptions(prevOptions => ({
                        ...prevOptions,
                        xaxis: { ...prevOptions.xaxis, categories }
                    }));
                    setBarChartSeries([{ name: "Total Registered", data }]);
                }
            } else {
                console.error('Failed to fetch data:', response.statusText);
            }
        };

        fetchData();
    }, [API_BASE_URL]);

    return (
        <div className="col-xxl-3 col-xl-6">
            <div className="card h-100 radius-8 border">
                <div className="card-body p-24">
                    <h6 className="mb-12 fw-semibold text-lg mb-16">Total Registered Last Week</h6>
                    <ReactApexChart options={barChartOptions} series={barChartSeries} type="bar" height={264} />
                </div>
            </div>
        </div>
    );
};

export default TotalSubscriberOneVolunteer;